import React from 'react';
import moment from 'moment';
import { dateExportFileFormat } from '../../../types/core/date.types';
import { CSVLink } from 'react-csv';
import { Button } from '@mui/material';

interface Column {
  headerName: string;
  field: string;
}

interface Props {
  data: any;
  fileName: string;
  // výběr sloupců, které exportovat pokud undefined, exportuji všechny sloupce
  filterColumns?: Column[];
  buttonTitle?: string;
}

export function ExportCsv({ data, fileName, filterColumns, buttonTitle = 'CSV' }: Props) {
  const headers = filterColumns?.map((col: Column) => col.headerName);
  const getFileName = () => {
    // fileName_2022-09-09.csv
    let date = moment().format(dateExportFileFormat);
    return fileName + '_' + date + '.csv';
  };

  // filtr na sloupce 
  let filteredData;
  if (filterColumns) {
    filteredData = data.map((item: any) => {
      let tmpItem: any = {}; 
      filterColumns.map((col: Column) => {
        return (tmpItem[col.field] = item[col.field]);
      });
      return tmpItem;
    });
    data = filteredData;
  }
  const prepData = data.map((item: any) => Object.values(item));

  return (
    <CSVLink
      data={prepData}
      headers={headers}
      filename={getFileName()}
      style={{ textDecoration: 'none', textAlign: 'center' }}
    >
      <Button variant="text">{buttonTitle}</Button>
    </CSVLink>
  );
}
